import Flex from "#blocks/Flex"
import TagWithTooltip from "#blocks/TagWithTooltip"

const TagIcons = ({ values }: { values?: string[] }) => {
  if (!values?.length) return null

  return (
    <Flex center style={{ width: "fit-content" }}>
      {values.map((val) => (
        <TagWithTooltip key={val} tagName={val} />
      ))}
    </Flex>
  )
}

export default TagIcons
